<template>
    <div class="flexcol-fill overflow-hidden">
        <div class="flexcol-fix bg-primary mt-2">
            <v-container fluid>
                <v-row no-gutters align="center">
                    <v-col>
                        Profil / Einstellungen
                    </v-col>
                    <v-col cols="auto">
                        <v-btn icon="mdi-close" color="primary" @click="close"/>
                    </v-col>
                </v-row>
            </v-container>
        </div>
        <v-container fluid class="flexcol-fill overflow-auto">
            <v-row>
                <v-col>
                    <v-tabs v-model="selectedTabLeft" class="mb-2">
                        <v-tab value="user"><v-icon icon="mdi-account-outline" class="mr-1"/> Angemeldeter Benutzer</v-tab>
                    </v-tabs>
                    <v-tabs-window v-model="selectedTabLeft">
                        <v-tabs-window-item value="user">
                            <v-text-field v-model="account.email" label="E-Mail-Adresse" disabled/>
                            <v-text-field v-model="account.vorname" label="Vorname" disabled/>
                            <v-text-field v-model="account.nachname" label="Nachname" disabled/>                    
                        </v-tabs-window-item>
                    </v-tabs-window>
                </v-col>
                <v-col>
                    <v-tabs v-model="selectedTabRight" class="mb-2">
                        <v-tab value="calendarService">Kalender-Dienst</v-tab>
                    </v-tabs>
                    <v-tabs-window v-model="selectedTabRight">
                        <v-tabs-window-item value="calendarService">
                            <v-progress-circular v-if="connectingCalendarService" indeterminate color="primary" class="ma-3"/>
                            <div v-if="!account.calendarService && !connectingCalendarService">
                                <f-api ref="calendarApi"/>
                                <v-container fluid>
                                    <v-row>
                                        <v-col cols="auto">
                                            <div class="clickItem border-light border-sm border-opacity-100 pa-3 text-center text-sm" @click="connectGoogle">
                                                <img src="/img/google.webp" style="height: 3rem;"/><br/>
                                                Google-Account verbinden
                                            </div>                                         
                                        </v-col>
                                        <v-col cols="auto">
                                            <div class="border-light border-sm border-opacity-100 pa-3 text-center text-sm">
                                                <img src="/img/apple.svg" style="height: 3rem;"/><br/>
                                                Apple-Account verbinden
                                            </div>                                                                                  
                                        </v-col>
                                        <v-col cols="auto">
                                            <div class="border-light border-sm border-opacity-100 pa-3 text-center text-sm">
                                                <img src="/img/microsoft.svg" style="height: 3rem;"/><br/>
                                                Microsoft-Account verbinden
                                            </div>                                                                                  
                                        </v-col>                                                                                
                                    </v-row>
                                </v-container>
                            </div>
                        </v-tabs-window-item>
                    </v-tabs-window>
                </v-col>
            </v-row>
        </v-container>
    </div>
</template>
<script>
const API_URL = import.meta.env.VITE_API_URL;
export default {
  name: 'f-profile',
  emits: ['close'],
  data() {
    return {
        selectedTabLeft: 'user',       
        selectedTabRight: 'calendarService',
        connectingCalendarService: false
    }
  },
  computed: {
    account() {
        const vm = this;
        return vm.$store.state.account;
    }
  },
  methods: {
    close() {
        this.$emit('close');
    },
    connectGoogle() {
        const vm = this;
        vm.connectingCalendarService = true;
        vm.$refs.calendarApi.get('google/connect', (redirectUrl) => {
            vm.connectingCalendarService = false;
            window.location.href = redirectUrl;
        }, () => {
            vm.connectingCalendarService = false;
        });
    }
  }
}
</script>
<style lang="css" scoped>

.clickItem {
    cursor: pointer;
    transition: transform 0.2s;
}
.clickItem:hover {
    transform: scale(1.05);
}
</style>